import { Injectable } from "@angular/core";
import { GlassLayer } from "./GlassLayer";

@Injectable({ providedIn: 'root' })
export class GlassLayerService {

    private layers = new Map<string, GlassLayer>();

    public getLayer(name: string): GlassLayer {
        if (!this.layers.has(name)) {
            this.layers.set(name, new GlassLayer());
        }
        return this.layers.get(name) as GlassLayer;
    }
}